import React, { FC, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { StyleSheet, View } from 'react-native'
import { color, spacing, fontSize, fontFamily, fontWeight } from '@partipost-cm-new/app-preview/dist/Styles/Base'
import { moderateScale } from '@partipost-cm-new/app-preview/dist/Utils/Scaling'
import Card from '@partipost-cm-new/app-preview/dist/Components/Card'
import PartiText from '@partipost-cm-new/app-preview/dist/Components/PartiText'
import { useNewTranslation } from 'hooks'
import { selectFollowFirstStepData, selectFollowInterpolationListData } from 'state/appPreview/selector/follow'
import SubmitPage from '../common/SubmitPage'
import MediaSubmitBlock from '../common/MediaSubmitBlock'
import TextSubmitBlock from '../common/TextSubmitBlock'
import PlaceholderComponent from 'components/AppPreview/common/InterpolationList'

const FollowPreview: FC = () => {
    const [t] = useNewTranslation()
    const firstStepData = useSelector(selectFollowFirstStepData)
    const interpolationListData = useSelector(selectFollowInterpolationListData)

    return (
        <Fragment>
            <SubmitPage stepIndex={'1'} totalStepNumber={'2'} buttonText={t('button.submit')}>
                <View style={{ paddingHorizontal: spacing.medium }}>
                    <PartiText style={styles.taskType}>
                        <PlaceholderComponent
                            template={interpolationListData?.taskTitle?.template || ''}
                            values={interpolationListData?.taskTitle?.values}
                        />
                    </PartiText>
                    <PartiText style={styles.stepTitle}>{firstStepData.stepTitle}</PartiText>
                    <Card cardStyle={styles.container}>
                        <PartiText style={styles.title}>{firstStepData.title?.toUpperCase()}</PartiText>
                        <PlaceholderComponent
                            template={interpolationListData?.description?.template || ''}
                            values={interpolationListData?.description?.values}
                        />
                    </Card>
                    {firstStepData.mediaBlockMaxPhotos !== undefined && (
                        <MediaSubmitBlock
                            title={firstStepData.mediaBlockTitle ?? ''}
                            maxPhotos={firstStepData.mediaBlockMaxPhotos ?? 0}
                            titleStyle={styles.mediaBlockTitle}
                        />
                    )}
                    {!!firstStepData.textBlockTitle && (
                        <TextSubmitBlock
                            title={firstStepData.textBlockTitle}
                            placeholder={t('placeholderText.tapToEnterText')}
                        />
                    )}
                </View>
            </SubmitPage>
        </Fragment>
    )
}
const styles = StyleSheet.create({
    taskType: {
        fontSize: moderateScale(12),
        fontWeight: fontWeight.medium,
    },
    stepTitle: {
        fontSize: moderateScale(24),
        fontFamily: fontFamily.title,
        fontWeight: fontWeight.bold,
        paddingTop: spacing.medium,
        paddingBottom: spacing.medium2,
    },
    title: {
        fontSize: fontSize.extraSmall,
        paddingBottom: spacing.small,
        color: color.tundora,
        fontFamily: fontFamily.copy,
    },
    container: {
        borderRadius: moderateScale(10),
        padding: spacing.medium,
        margin: 0,
        marginBottom: spacing.medium2,
    },
    mediaBlockTitle: {
        fontWeight: fontWeight.bold,
    },
})

export default FollowPreview
